export const COMPANY = {
  name: "DADA PRINT ART",
  tagline: "Precision in Every Print",
  description:
    "Trusted partner for quality label solutions — manufacturing high-quality roll form sticker labels for pharmaceuticals, FMCG, cosmetics, food & beverages and pesticides.",
  phone: "+91 79866 58415",
  phoneRaw: "+917986658415",
  email: "indianprinter@gmail.com",
  address:
    "DADA PRINT ART, 768, JLPL Industrial Park, Sector 82, Mohali, Punjab, India",
  domain: "www.dadaprintart.com",
  mapQuery:
    "DADA+PRINT+ART+768+JLPL+Industrial+Park+Sector+82+Mohali",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/industries", label: "Industries" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact" },
];

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_dada-labels/artifacts/dcwkcsoi_DPA%20LOGO%20PNG%20Files.png";

export const MEDIA = {
  heroBackground:
    "https://static.prod-images.emergentagent.com/jobs/1a41a5aa-f0e9-43b7-ad34-e3a018a5157b/images/b75ce9e572d3df711652fb4391510c78a869c6d221199fe5b71a073009fb1d3e.png",
  machine1:
    "https://customer-assets.emergentagent.com/job_dada-labels/artifacts/i3fz55bu_FS350-PIC.png",
  machine2:
    "https://customer-assets.emergentagent.com/job_dada-labels/artifacts/i3fz55bu_FS350-PIC.png",
  labels: [
    "https://images.unsplash.com/photo-1617912760188-9ef603157f1e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxyb2xsJTIwbGFiZWxzJTIwc3RpY2tlcnMlMjBwYWNrYWdpbmd8ZW58MHx8fHwxNzc2NDk5Njg3fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1605718317361-f9326fd262ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxyb2xsJTIwbGFiZWxzJTIwc3RpY2tlcnMlMjBwYWNrYWdpbmd8ZW58MHx8fHwxNzc2NDk5Njg3fDA&ixlib=rb-4.1.0&q=85",
  ],
  cosmetics:
    "https://images.unsplash.com/photo-1767256046031-743d33937c4e?auto=format&fit=crop&w=1600&q=80",
  pharma:
    "https://images.unsplash.com/photo-1763142842692-b3e649aae313?auto=format&fit=crop&w=1600&q=80",
  beverage:
    "https://images.unsplash.com/photo-1703564803557-9bb5980a1ef0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxiZXZlcmFnZSUyMGJvdHRsZXMlMjBwYWNrYWdpbmd8ZW58MHx8fHwxNzc2NDk5NzA2fDA&ixlib=rb-4.1.0&q=85",
  fmcg:
    "https://images.unsplash.com/photo-1607344645866-009c320b63e0?auto=format&fit=crop&w=1600&q=80",
  household:
    "https://images.unsplash.com/photo-1585421514738-01798e348b17?auto=format&fit=crop&w=1600&q=80",
  pesticides:
    "https://images.unsplash.com/photo-1625246333195-78d9c38ad449?auto=format&fit=crop&w=1600&q=80",
  pharmaAlt:
    "https://images.unsplash.com/photo-1763142843509-7a7312482073?auto=format&fit=crop&w=1600&q=80",
  pharmaSyrup:
    "https://images.unsplash.com/photo-1573208135184-851d2e374a98?auto=format&fit=crop&w=1600&q=80",
  cosmeticsAlt:
    "https://images.unsplash.com/photo-1771955216611-0a826d819978?auto=format&fit=crop&w=1600&q=80",
};

export const INDUSTRIES = [
  {
    key: "pharma",
    title: "Pharmaceuticals",
    description:
      "Compliant, durable labels for injection vials, ampoules, syrups, mouthwash and cartons — high-legibility print with tamper-evident and batch coding options.",
    image: MEDIA.pharma,
    accent: "#00B4F0",
  },
  {
    key: "cosmetics",
    title: "Cosmetics & Personal Care",
    description:
      "Premium labels for Vitamin C serums, niacinamide, creams and beauty packaging — foil-stamped, UV-gloss and laminated for a high-end shelf finish.",
    image: MEDIA.cosmetics,
    accent: "#E6007E",
  },
  {
    key: "beverage",
    title: "Food & Beverage",
    description:
      "Food-safe, moisture-resistant stickers built for chilled bottles, cans, jars and premium F&B SKUs.",
    image: MEDIA.beverage,
    accent: "#FFD100",
  },
  {
    key: "fmcg",
    title: "FMCG",
    description:
      "Fast-moving consumer goods labels optimised for speed, accuracy and high-volume production runs.",
    image: MEDIA.fmcg,
    accent: "#00B4F0",
  },
  {
    key: "household",
    title: "Household Products",
    description:
      "Abrasion-resistant multicolour labels for detergents, cleaners and home-care containers.",
    image: MEDIA.household,
    accent: "#E6007E",
  },
  {
    key: "pesticides",
    title: "Pesticides",
    description:
      "Chemical-resistant, weatherproof labels engineered for agrochemical containers and regulatory compliance.",
    image: MEDIA.pesticides,
    accent: "#FFD100",
  },
];

export const SERVICES = [
  {
    title: "Self-Adhesive Roll Form Labels",
    description:
      "High-precision roll form sticker labels on paper, PP, PE, PET and specialty substrates — ready for automated applicators.",
    badge: "Core",
  },
  {
    title: "Custom Die-Cut & Multicolour Printing",
    description:
      "Any shape, any colour. Sharp registration, CMYK + spot colours, and complex die-cuts produced in-house.",
    badge: "Signature",
  },
  {
    title: "Foil Stamping",
    description:
      "Hot & cold foil stamping in gold, silver and holographic finishes for premium shelf presence.",
    badge: "Premium",
  },
  {
    title: "UV & Spot UV Finishing",
    description:
      "UV coatings that protect against scuffing, moisture and fading — with spot UV for tactile highlights.",
    badge: "Finish",
  },
  {
    title: "Lamination",
    description:
      "Gloss, matte and soft-touch laminations to extend label life and deliver a premium feel.",
    badge: "Finish",
  },
  {
    title: "Specialty Finishes",
    description:
      "Embossing, debossing, variable data printing, barcoding and sequential numbering on request.",
    badge: "Custom",
  },
];

export const WHY_US = [
  {
    title: "Spare Capacity Available",
    description:
      "3,00,000+ sq. meters per month capacity — we can absorb new volume immediately.",
  },
  {
    title: "Fast Turnaround",
    description:
      "Advanced machinery and streamlined workflows keep delivery schedules tight.",
  },
  {
    title: "Consistent Quality",
    description:
      "Experienced team, strict QC checks and mature print-registration systems.",
  },
  {
    title: "Competitive Pricing",
    description:
      "Best-in-class quality at cost-effective rates — designed for scale.",
  },
  {
    title: "Flexible Customisation",
    description:
      "Tailored label solutions for every substrate, every industry, every brief.",
  },
  {
    title: "Personalised Service",
    description:
      "A dedicated account partner — not a ticket number — guiding every project.",
  },
];
